import React from 'react';
import { Clock, Bell, MapPin } from 'lucide-react';
import { getMonthAbbr } from '../utils/dateUtils';

const priorityBadgeClass = {
  essential: 'bg-red-500 text-white',
  aware: 'bg-amber-400 text-amber-900',
  flexible: 'bg-green-500 text-white',
};

export default function EventRow({
  event,
  onClick,
  showDate = false,
}) {
  return (
    <button
      onClick={onClick}
      className={`w-full ${event.color} border-l-4 rounded-lg text-left hover:shadow-md transition-shadow p-3`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <div className="font-semibold text-gray-900 text-sm">
              {event.title}
            </div>
            {event.tags?.map(tag => (
              <span key={tag} className={`${priorityBadgeClass[tag] || 'bg-gray-500 text-white'} text-xs font-bold px-2 py-0.5 rounded-full uppercase`}>
                {tag}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-2 text-gray-600 text-xs">
            <Clock size={12} />
            <span>{event.time}</span>
            {!showDate && event.needsPrep && (
              <>
                <span className="text-gray-400">&bull;</span>
                <span className="flex items-center gap-1">
                  <MapPin size={12} className="text-yellow-600" />
                  <span className="text-yellow-600 font-medium">30m prep</span>
                </span>
              </>
            )}
            {showDate && (
              <>
                <span className="text-gray-400">&bull;</span>
                <span>{getMonthAbbr(event.month)} {event.day}, {event.year}</span>
              </>
            )}
          </div>
        </div>
        {event.alert && (
          <Bell size={16} className="text-gray-500 flex-shrink-0" />
        )}
      </div>
    </button>
  );
}
